import { render, staticRenderFns } from "./SendSafetyConfirmToOtherUserDetail.vue?vue&type=template&id=115050f0&lang=pug"
import script from "./SendSafetyConfirmToOtherUserDetail.vue?vue&type=script&lang=ts"
export * from "./SendSafetyConfirmToOtherUserDetail.vue?vue&type=script&lang=ts"
import style0 from "./SendSafetyConfirmToOtherUserDetail.vue?vue&type=style&index=0&id=115050f0&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports